import {registerStyle, styleRule, UI} from "../../../../../../stem-core/src/ui/UI";
import {StyleSheet} from "../../../../../../stem-core/src/ui/UI";
import {Messages} from "../../../../../Messages";
import {BUTTON_TYPE} from "../../../../../Constants";

import {SubscribeButton} from "./SubscribeButton";
import {subscribeFlowState} from "../../../../inline-subscription/SubscribeFlowState";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {CoveragePreview} from "./CoveragePreview";
import {isSmallScreen} from "../../../../../UtilsLib";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {SUBSCRIBE_PLAN_STATE, subscribePlanController} from "../../../../inline-subscription/SubscribePlanController";


class SubscriptionCoverageCardStyle extends StyleSheet {
    @styleRule
    coverageCard = {
        display: "flex",
        flexDirection: "column",
        width: isSmallScreen() ? 326 : 350,
        background: this.themeProps.MERCHANT_CARD_BACKGROUND,
        padding: "18px 24px 24px",
        border: "1px solid " + this.themeProps.MERCHANT_CARD_BORDER_COLOR,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        boxShadow: this.themeProps.MERCHANT_CARD_BOX_SHADOW,
    };

    @styleRule
    buttonsContainer = {
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-end",
        width: "100%",
        marginTop: "auto",
        ">:not(:first-child)": {
            marginTop: 10,
        }
    }
}

@registerStyle(SubscriptionCoverageCardStyle)
export class SubscriptionCoverageCard extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            coverage: null,
            onSubscriptionOfferSelected: NOOP_FUNCTION,
            testId: "subscriptionCoverageCard",
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.coverageCard);
    }

    getFormattedSubscriptionOfferPrice(offer) {
        return `${subscribeFlowState.getSubscriptionOfferPrice(offer, subscribeFlowState.getDiscountInfo(offer))}/${offer.getCycleDuration()}`
    }

    getOfferLabel(offer) {
        if (subscribePlanController.subscribePlanState === SUBSCRIBE_PLAN_STATE.subscribe) {
            const subscriptionOffers = this.options.coverage.getAvailableOffers();

            return subscriptionOffers.length > 1 ?
                Messages.subscribeInlineFlowButton(this.getFormattedSubscriptionOfferPrice(offer))
                : Messages.subscribe
        }

        const formattedPrice = this.getFormattedSubscriptionOfferPrice(offer);
        return this.userHasEquivalentSubscription(offer) ? Messages.subscribedButtonLabel(formattedPrice) : Messages.changePlanButtonLabel(formattedPrice);
    }

    userHasEquivalentSubscription(offer) {
        if (subscribePlanController.subscribePlanState === SUBSCRIBE_PLAN_STATE.subscribe) {
            return false;
        }

        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        return !!activeSubscription && activeSubscription.billingPlan === offer.billingPlan && activeSubscription.coverage === offer.coverage;
    }

    render() {
        const {styleSheet} = this;
        const {coverage, onSubscriptionOfferSelected} = this.options;
        const subscriptionOffers = coverage.getAvailableOffers();

        if (subscriptionOffers.length === 0) {
            return null;
        }

        return [
            <CoveragePreview coverage={coverage} subscriptionOffers={subscriptionOffers}/>,
            <div className={styleSheet.buttonsContainer}>
                <SubscribeButton type={BUTTON_TYPE.PRIMARY} offer={subscriptionOffers[0]} disabled={this.userHasEquivalentSubscription(subscriptionOffers[0])}
                                 onClick={() => onSubscriptionOfferSelected(subscriptionOffers[0])}>
                    {this.getOfferLabel(subscriptionOffers[0])}
                </SubscribeButton>
                {
                    subscriptionOffers.slice(1).map(offer => <SubscribeButton type={BUTTON_TYPE.SECONDARY} disabled={this.userHasEquivalentSubscription(offer)}
                                                                              onClick={() => onSubscriptionOfferSelected(offer)} style={{width: "100%"}}>
                        {this.getOfferLabel(offer)}
                    </SubscribeButton>)
                }
            </div>
        ];
    }
}
